import Range from './Range'
import RangePromo from './RangePromo'

export default class Ranges {
    constructor(ranges) {
        this.ranges = ranges
    }

    contains(date) {
        for (let k in this.ranges) {
            let rangePromo = this.ranges[k]
            // eslint-disable-next-line
            //console.log(rangePromo, rangePromo.range)
            if (rangePromo.range.contains(date)) {
                return rangePromo
            }
        }
        return null;
    }
    containsIndex(date) {
        for (let k in this.ranges) {
            let rangePromo = this.ranges[k]
            // eslint-disable-next-line
            //console.log(rangePromo, rangePromo.range)
            if (rangePromo.range.contains(date)) {
                return k
            }
        }
        return null;
    }

    addRange(range, color, percentage) {
        let toDelete = []
        let intersected = false

        for (let k in this.ranges) {
            if (this.ranges[k].range.isContainedBy(range)) {
                toDelete.push(this.ranges[k])
            }
            if (this.ranges[k].range.intersect(range)) {
                this.ranges[k].range.merge(range)
                intersected = this.ranges[k]
            }
        }

        for (let idlt in toDelete) {
            this.remove(toDelete[idlt])
        }

        if (intersected === false) {
            let nr = new RangePromo(range, color, percentage)
            this.ranges.push(nr)
            return nr
        } else {
            return intersected
        }
    }

    remove(range) {
        this.ranges = this.ranges.filter(r => r !== range)
    }

    toTimeStamps(sec = false) {
        return this.ranges.map(range => {
            return range.toTimeStamps(sec)
        })
    }

    static fromTimeStamps(rangesPromo, sec = false) {
        return new Ranges(rangesPromo.map(rangePromo => {
            return new RangePromo(Range.fromTimeStamps(rangePromo.range, sec), rangePromo.color, rangePromo.percent)
        }))
    }

}